import React, { Component } from "react";
import { connect } from 'react-redux';
import { Field, reduxForm, reset } from 'redux-form'
import { loadInitialAdditionalDetails } from './action';
import { Form, FormGroup, ModalHeader, ModalBody, ModalFooter, Row, Col, Button, Label } from 'reactstrap';
import * as constant from "../../../constants";

const renderField = ({ input, label, type, isRequired, val, meta: { touched, error, warning } }) => (
    <Row className="mb-3 align-items-center">
        <Col sm="9">
            <label className="mb-0">{label}</label>
            {(isRequired && <span className="text-danger">*</span>)}
        </Col>
        <Col sm="15">
            <input {...input} placeholder={label} type={type} className="form-control" />
            {touched &&
                ((error && <span className="text-danger">{error}</span>) ||
                    (warning && <span className="text-warning">{warning}</span>))}
        </Col>
    </Row>
)
class AdditionalFieldsForm extends Component {

    componentDidMount() {
        this.props.load(this.props.additionalFields);
    }

    componentWillUnmount() {
        this.props.load({});
    }

    componentDidUpdate(prevProps) {
        if (this.props.additionalFields !== prevProps.additionalFields) {
            this.props.load(this.props.additionalFields);
        }
    }

    render() {
        const { handleSubmit, pristine, submitting, reset } = this.props
        return (
            <Row>
                <form className="modal-content shadow-none border-0" onSubmit={handleSubmit((val) => this.props.submitAdditionalDetails(val))}>
                    <ModalHeader>
                        Additional Details
                    </ModalHeader>
                    <ModalBody>
                        <Field
                            name="enquiryReferenceNumber"
                            type="text"
                            component={renderField}
                            label="Enquiry Reference Number"
                        />
                        <Field
                            name="buyerCode"
                            type="text"
                            component={renderField}
                            label="Buyer Code"
                        />
                        <Field
                            name="indianPartyName"
                            type="text"
                            component={renderField}
                            label="Indian Party Name"
                        />
                        <Field
                            name="counterpartyContactDetails"
                            type="text"
                            component={renderField}
                            label="Contact Details"
                        />
                        <Field
                            name="counterpartyWebsite"
                            type="text"
                            component={renderField}
                            label="Website"
                        />
                        <Field
                            name="counterpartyEmail"
                            type="text"
                            component={renderField}
                            label="Email"
                        />
                        <Field
                            name="otherEnquiryDetails"
                            type="text"
                            component={renderField}
                            label="Other Enquiry Details"
                        />
                        <Field
                            name="discloseCorporate"
                            type="checkbox"
                            component={renderField}
                            label="Disclose Corporate?"
                        />
                    </ModalBody>
                    <ModalFooter>
                        <Row>
                            <Col ><Button color="info" size="lg" className="justify-content-center" onClick={() => this.props.handleAddDetailsModalButton(constant.CLOSE)} > Cancel </Button></Col>
                            <Col ><Button type="submit" color="info" size="lg" className="justify-content-center" disabled={submitting}>Submit</Button></Col>
                        </Row>
                    </ModalFooter>
                </form>
            </Row>
        )
    }
}

AdditionalFieldsForm = reduxForm({
    form: 'additionaldetailsForm', // a unique identifier for this form
    enableReinitialize: true
})(AdditionalFieldsForm);

AdditionalFieldsForm = connect(
    state => ({
        initialValues: state.additionalFieldsInitialValuesReducer.intialAdditionalFields // pull initial values from reducer
    }),
    { load: loadInitialAdditionalDetails }, // bind addition fields loading action creator
)(AdditionalFieldsForm);

export default AdditionalFieldsForm;
